//校验移动电话
export const checkPhone = (_, value, callback) => {
  let arr = value.split('/');
  if (arr[arr.length - 1] == '') {
    arr = arr.slice(0, arr.length - 1);
  }
  let reg = /^1[3456789]\d{9}$/;
  let flag = false;
  arr.forEach((item) => {
    if (!reg.test(item)) {
      flag = true;
    }
  });
  if (flag) {
    callback(new Error('电话格式不正确'));
  } else {
    callback();
  }
};

export const baseRules = {
  // applyDepartmentNo: { required: true, message: '请选择申请部门' },
  applyDepartmentName: [{ required: true, message: '请选择申请部门', tirgger: 'change' }],
  bidTitle: [{ required: true, message: '请选择投标抬头', tirgger: 'change' }],
  bidderId: [{ required: true, message: '请选择业务', tirgger: 'change' }],
  // bidderName: { required: true, message: '请选择投标人员' },
  applyDate: [{ required: true, message: '请输入立项申请日期', tirgger: 'blur' }],
  projectName: [{ required: true, message: '请输入项目名称', tirgger: 'blur' }],
  // projectCode: { required: true, message: '请输入项目编号' },
  projectSourceType: [{ required: true, message: '请选择项目来源', tirgger: 'change' }],
  /*   bidOpeningDate: [{ required: true, message: '请选择开标日期', tirgger: 'blur' }],
  bidClosingDate: [{ required: true, message: '请选择截标日期', tirgger: 'blur' }], */
  projectNature: [{ required: true, message: '请选择项目性质', tirgger: 'change' }],
  customerCodeOne: [{ required: true, message: '请选择客户1名称', tirgger: 'change' }],
  customerCodeTwo: [{ required: true, message: '请选择客户2名称', tirgger: 'change' }],
  customerCodeThree: [{ required: true, message: '请选择客户3名称', tirgger: 'change' }],
  customerTypeOne: [{ required: true, message: '请选择客户1类型', tirgger: 'change' }],
  customerTypeTwo: [{ required: true, message: '请选择客户2类型', tirgger: 'change' }],
  customerTypeThree: [{ required: true, message: '请选择客户3类型', tirgger: 'change' }],
  customerContactPhoneOne: [{ validator: checkPhone, message: '电话格式不正确' }],
  customerContactPhoneTwo: [{ validator: checkPhone, message: '电话格式不正确' }],
  customerContactPhoneThree: [{ validator: checkPhone, message: '电话格式不正确' }],
  // serviceTypeName: { required: true, message: '请选择服务类型' },
  serviceTypeCode: [{ required: true, message: '请选择服务类型', tirgger: 'change' }],
  /*   projectStartDate: [{ required: true, message: '请选择项目开始日期', tirgger: 'blur' }],
  projectEndDate: [{ required: true, message: '请选择项目开始日期', tirgger: 'blur' }], */
};
